export const FinanceLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M9 14.0524V17.4215H9.85V22.473H9V24.9992H22.6L25.15 25L26 24.9992V22.473H25.15V17.4215H26V14.0524L17.5 9L9 14.0524ZM12.4 22.473V17.4215H14.1V22.473H12.4ZM16.65 22.473V17.4215H18.35V22.473H16.65ZM22.6 22.473H20.9V17.4215H22.6V22.473ZM19.2 14.0524C19.1999 14.2736 19.1559 14.4926 19.0704 14.697C18.9849 14.9013 18.8596 15.087 18.7017 15.2434C18.5437 15.3998 18.3562 15.5238 18.1499 15.6084C17.9436 15.693 17.7225 15.7365 17.4992 15.7365C17.2758 15.7364 17.0547 15.6928 16.8485 15.6081C16.6422 15.5234 16.4548 15.3993 16.2969 15.2428C16.139 15.0863 16.0138 14.9006 15.9284 14.6962C15.843 14.4918 15.7991 14.2727 15.7991 14.0515C15.7993 13.6048 15.9785 13.1763 16.2975 12.8605C16.6165 12.5447 17.049 12.3673 17.5 12.3674C17.951 12.3675 18.3834 12.5451 18.7023 12.8611C19.0211 13.1771 19.2001 13.6056 19.2 14.0524Z"
        fill="#05050D"
        fillOpacity="0.3"
      />
    </svg>
  );
};
